import { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { UniversalPortal } from '@jesstelford/react-portal-universal'
import { MdClose, MdSearch } from 'react-icons/md'
import PropTypes from 'prop-types'
import Message from 'common/message'
import AnimatedModal from 'common/animations/animated-modal'
import { FaGithub } from 'react-icons/fa'
import { useSearchRepo, useFirstRepos } from 'querys/github'
import useClickOutside from 'hooks/use-click-outside'
import { SecondaryButton, SecondaryButtonOutline, TransparentButton as TB } from 'common/button'
import { useUpdateProjectStatus, handleUpdate } from 'mutations/projects'
import { LinearProgress } from '@material-ui/core'
import RepositoriesList from './repositories-list'
import RepositoryStatus from './repository-status'
import RepositiesFormStyled from './repositories-form-styled'
import NoRepos from './no-repos'

const TransparentButton = styled(TB)`
  width: 24px;
  height: 24px;
  background: no-repeat url(/images/profile/closed.png);
`

function Repositories({
  modal, project, setModal, username,
}) {
  const ref = useRef()
  const {
    mutate, error, success, setError, errorMessage, isLoading: isSendingToRevision,
  } = useUpdateProjectStatus()
  const { data: initalRepos, isError } = useFirstRepos()
  const {
    value, setValue, setEnabled, data, isLoading: searchLoading,
  } = useSearchRepo()
  const [projectFiltered, setProjectsFiltered] = useState(null)
  const [selected, setSelected] = useState({})
  const [disabled, setDisabled] = useState(true)
  useEffect(() => {
    if (value === '') {
      setSelected({})
    }
  }, [value])
  useEffect(() => {
    if (error) {
      setDisabled(true)
    }
    if (success) {
      setModal(false)
    }
  }, [error, success])
  const handleSumit = (e) => {
    e.preventDefault()
    if (disabled) return
    const {
      homepage, topics, name, description,
    } = selected
    handleUpdate({
      project,
      repository_slug: name,
      project_url: homepage,
      stack: topics,
      mutation: mutate,
      description,
      level: document.querySelector('input[name="requirements_level"]:checked')?.value,
    })
  }
  const handleChange = (e) => {
    setValue(e.target.value)
    const filter = initalRepos?.filter(({ name }) => name.toLowerCase().includes(e.target.value))

    if (filter?.length > 0) {
      setProjectsFiltered(filter)
      setEnabled(false)
    } else {
      setProjectsFiltered([])
      setEnabled(true)
    }
  }

  const closeRepoList = () => {
    setDisabled(true)
    setSelected({})
    setValue('')
    setError(false)
  }
  const handleClose = (e) => {
    if (e) {
      e.preventDefault()
    }
    setEnabled(true)
    setSelected({})
    setDisabled(true)
    setValue('')
    setModal(false)
  }
  const closeOverlay = (e) => {
    if (e?.target?.id === 'overlay') {
      handleClose()
    }
  }
  useClickOutside(ref, closeOverlay)
  return (
    <UniversalPortal selector="#page-portal">
      <AnimatedModal show={modal}>
        {/* <Wrapper> */}
        <RepositiesFormStyled id="overlay">
          <form id="repo-form" className="form" role="search" aria-labelledby="Seleccionar repositorio" ref={ref}>
            <div className="close">
              <MdClose size="28px" role="button" onClick={() => handleClose()} />
            </div>
            <fieldset className="form-fieldset">
              <legend className="form-legend">Vincular repositorio</legend>
              <label className="form-label" htmlFor="search_repo">
                <FaGithub size="20px" />
                <span>Github:</span>
                <span className="bold-span">
                  {' '}
                  {username}
                </span>
                <span className="bold-span">
                  {' '}
                  {selected?.name ? `/ ${selected.name}` : '' }
                </span>
              </label>
              {isSendingToRevision && (
                <div className="loading-bar">
                  <LinearProgress />
                </div>
              )}
              {!selected?.name && (
              <div className="form-input">
                <MdSearch size="27" color="var(--neutral80)" />
                <input
                  id="search_repo"
                  type="text"
                  value={value}
                  onChange={(e) => handleChange(e)}
                  placeholder="Buscar repositorio"
                  autoComplete="off"
                />
                {value !== '' && <TransparentButton id="restart-form" onClick={() => closeRepoList()} />}
              </div>
              )}
              {isError && (
                <Message error>
                  Ha ocurrido un error al cargar tus repositorios, comunicalo con nosotros a
                  {' '}
                  <a href="mailto:me@leonidasesteban.com">me@leonidasesteban.com</a>
                  {' '}
                  o a travez del medio de tu preferencia.
                </Message>
              )}
              {value === '' && !selected?.name && <NoRepos />}
              {value !== '' && !selected?.name && (
                <RepositoriesList
                  projectFiltered={projectFiltered}
                  repos={data?.items}
                  setSelected={setSelected}
                  searchLoading={searchLoading}
                />
              )}
              {selected?.name && (
              <RepositoryStatus
                selected={selected}
                setDisabled={setDisabled}
                setSelected={setSelected}
                closeRepo={closeRepoList}
              />
                )}
              {error && (
              <Message margin="8px 0px 0px 16px" error>
                {errorMessage || (
                  <>
                    Ha ocurrido un error interno, por favor reportalo en discord.
                  </>
                )}
              </Message>
              )}
              {/* {isLoading && ( */}
              {/* )} */}
              <div className="form-btns">
                <SecondaryButtonOutline height="40" fullWidth onClick={(e) => handleClose(e)}>
                    Cancelar
                </SecondaryButtonOutline>
                <SecondaryButton height="40" disabled={disabled} onClick={(e) => handleSumit(e)} fullWidth>
                    Mandar a revisión
                </SecondaryButton>
              </div>
            </fieldset>
          </form>
        </RepositiesFormStyled>
        {/* </Wrapper> */}
      </AnimatedModal>
    </UniversalPortal>
  )
}

Repositories.propTypes = {
  project: PropTypes.string.isRequired,
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
}

export default Repositories
